/**
 * Helper utility for displaying GAK + EAK consistently across the app.
 * If eak_number is missing, attempts to extract it from last_hearing_date
 * (format: "<pinakio> - <tmima> - <date> - <eak>").
 */

export const extractEakFromLastHearing = (lhd) => {
  if (!lhd) return null;
  const s = String(lhd).trim();
  if (!s || ["none", "nan", "null"].includes(s.toLowerCase())) return null;
  const parts = s.split(" - ").map((x) => x.trim());
  const last = parts[parts.length - 1];
  if (last && /^\d+$/.test(last)) return last;
  return null;
};

export const getEak = (caseObj) => {
  if (!caseObj) return null;
  const raw = caseObj.eak_number;
  if (raw && !["None", "none", "nan", ""].includes(String(raw))) {
    return String(raw);
  }
  return extractEakFromLastHearing(caseObj.last_hearing_date);
};

export const formatGakEak = (caseObj, options = {}) => {
  if (!caseObj) return "";
  const sep = options.sep || " · ";
  const gak = `ΓΑΚ ${caseObj.gak_number}/${caseObj.gak_year}`;
  const eak = getEak(caseObj);
  // ΥΠΟΧΡΕΩΤΙΚΗ εμφάνιση ΕΑΚ — αν λείπει, εμφάνιση με placeholder "—".
  return `${gak}${sep}ΕΑΚ ${eak || "—"}/${caseObj.gak_year}`;
};

export const GakEak = ({ caseObj, sep = " · ", className = "" }) => {
  if (!caseObj) return null;
  const eak = getEak(caseObj);
  return (
    <span className={className} data-testid="gak-eak">
      ΓΑΚ {caseObj.gak_number}/{caseObj.gak_year}
      {sep}
      ΕΑΚ {eak || "—"}/{caseObj.gak_year}
    </span>
  );
};
